import {getIsUserGlobalAdmin} from '../../../../libs/shared/core/src/store/data/access/commonAccessSelectors';
import {createSelector} from '../../../../srcCommon/helpers/reselectHelpers';
import {MILLISECONDS_PER_DAY} from '../../../settings/billing/helpers';
import {getIsInTrialOrExpired} from '../../../store/data/company/companySelectors';
import {getBillingDetails} from '../../../store/metadata/billing/billingSelectors';

/*
 * Selectors.
 */

export const getIsTrialBottomBarVisible = createSelector(
  [getIsUserGlobalAdmin, getIsInTrialOrExpired],
  (isGlobalAdmin, isInTrialOrExpired) => isGlobalAdmin && isInTrialOrExpired,
);

export const getBillingIsCancellingInfo = createSelector([getBillingDetails], (billingDetails) => {
  const daysLeftBeforeCancel = billingDetails?.endDate
    ? Math.ceil((billingDetails.endDate - Date.now()) / MILLISECONDS_PER_DAY)
    : -1;

  return {
    daysLeftBeforeCancel,
    commitmentTerm: billingDetails?.commitmentTerm,
  };
});

export const getIsCancellingBottomBarVisible = createSelector(
  [getIsUserGlobalAdmin, getBillingDetails, getBillingIsCancellingInfo],
  (isGlobalAdmin, billingDetails, {daysLeftBeforeCancel}) =>
    isGlobalAdmin &&
    Boolean(billingDetails?.isCancelled && !billingDetails?.amCovered) &&
    daysLeftBeforeCancel <= 7,
);
